import React, { useEffect } from 'react';
import { PseudoStates } from '@cordata/buffet';
import { find } from 'lodash';

import { baseInstance as py } from '~/utils';

const LoginForm = () => {
  useEffect(() => {
    py
      .get('/destinations')
      .then(r => r.data.data)
      .then((r) => {
        console.log(r);

        const gk = find(r, ['name', 'Gatekeeper']);

        window.location = `${gk.url}/login`;
      });
  }, []);

  return (
    <PseudoStates isLoading />
  );
};

export default LoginForm;
